import moment from "moment";
import { me } from "constants/Client";
import { fullDateFormat } from "constants/TaskConstants";
import {
  getAdminsList,
  getEvents,
  getEventsList,
  getIncidentList,
  getLocationsList,
  getManagerList,
  getMyNotificatins,
  getParticipants,
  getRiskAssessmentList,
  getShifts,
  getStaff,
} from "store/actions";
import { givenTimeToUtc } from "./timeConversions";

export const callParticipantList = (dispatch, active = "active", location = "", rest) => {
  dispatch(
    getParticipants({
      location_value: location ? location : "",
      [active]: "1",
      admintype: me().role,
      ...rest,
    })
  );
};

export const callEmployeeList = (dispatch, active = "active", location = "", rest) => {
  dispatch(
    getStaff({
      location_value: location ? location : "",
      [active]: "1",
      type: "all",
      ...rest,
    })
  );
};

export const callAdminList = (dispatch, rest) => {
  dispatch(getAdminsList({ ...rest }));
};

export const callManagerList = (dispatch, location = "", rest) => {
  dispatch(
    getManagerList({
      super_admin: "0",
      location_value: location ? location : "",
      ...rest,
    })
  );
};

export const callTaskList = (dispatch, from_date, end_date, isSearch = "0", rest) => {
  dispatch(
    getEvents({
      isSearch,
      ...(from_date && { from_date: givenTimeToUtc(`${from_date} 00:00:00`, fullDateFormat) }),
      ...(end_date && { end_date: givenTimeToUtc(`${end_date} 23:59:59`, fullDateFormat) }),
      ...rest,
    })
  );
};

export const onGettingTaskList = (dispatch, { from_date, end_date, isSearch = "0", ...rest }) => {
  dispatch(
    getEventsList({
      isSearch,
      ...(from_date && { from_date: givenTimeToUtc(`${from_date} 00:00:00`, fullDateFormat) }),
      ...(end_date && { end_date: givenTimeToUtc(`${end_date} 23:59:59`, fullDateFormat) }),
      ...rest,
    })
  );
};

export const callRisAssessmentList = (dispatch, { page = 1, limit = 20 } = {}) => {
  dispatch(
    getRiskAssessmentList({
      admintype: me().role,
      page,
      limit,
    })
  );
};

export const callIncidentList = (dispatch, rest) => {
  dispatch(
    getIncidentList({
      admintype: me().role,
      ...rest,
    })
  );
};

export const callShiftList = (dispatch, from_date_time, to_date_time, rest) => {
  dispatch(
    getShifts({
      location: "",
      shiftType: localStorage.getItem("tab"),
      ...rest,
      ...(from_date_time && { from_date_time: givenTimeToUtc(`${from_date_time} 00:00:00`, fullDateFormat) }),
      ...(to_date_time && { to_date_time: givenTimeToUtc(`${to_date_time} 23:59:59`, fullDateFormat) }),
    })
  );
};

export const showNotifications = dispatch => {
  if (!me().uid) return;
  dispatch(getMyNotificatins({}));
};

// state in state.Profile.locationList
export const callLocationList = dispatch => {
  dispatch(
    getLocationsList({
      admintype: me().role,
    })
  );
};
